module.exports = __webpack_public_path__ + "static/media/JH_web_3.1c4ffddf.jpg";